import { forwardRef, useRef } from "react";
import CustomSearch from "../../shared/CustomSearch";

const DoctorSearch = forwardRef(function DoctorSearch(
  {
    onChange,
    notFoundData,
    optionalProps,
    alwaysShowNotFoundData = false,
    clearAfterChange = true,
  },
  ref
) {
  //const searchRef = useRef(null);
  const onSearch = (q) => {
    var data = [
      {
        id: 1,
        label: "Dr. Ram",
        contact: "6547893214",
        registration: "reg1234",
      },
      {
        id: 2,
        label: "Dr. Shayam",
        contact: "8796541230",
        registration: "reg4567",
      },
    ];
    if (notFoundData) {
      if (alwaysShowNotFoundData || data.length === 0) data.push(notFoundData);
    }
    return data;
  };
  return (
    <CustomSearch
      onSearch={onSearch}
      onChange={(s) => {
        if (onChange instanceof Function) {
          if (s.length > 0) {
            const selected = s[0];
            onChange(selected);
          } else {
            onChange(null);
          }
        }
        // console.log(s, searchRef);
      }}
      clearAfterChange={clearAfterChange}
      ref={ref}
      otherRequiredProps={{
        id: "doctorSearch",
        placeholder: "Kapid Id, Name, Mobile Number, Registration Number",
        autoFocus: true,
        ...optionalProps,
      }}
    />
  );
});

export default DoctorSearch;
